import { createSimplePageStrategy } from './simple-page.strategy-helper';

export const DestinationSeoStrategy = createSimplePageStrategy(
  'destination',
  'destination',
  '/destination'
);
